export default __webpack_public_path__ + "static/media/Decor-for-Room-.ce7767e0.jpg";